import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'suka-mobile-navigation',
  template: `
    <button class="nav-toggle" (click)="toggle()"><suka-icon icon="menu"></suka-icon> NavegaciÃ³n</button>
    <div class="backdrop--dark"></div>
    <div class="mobile-navigation__nav-wrapper">
      <div class="mobile-nav-trigger" (click)="toggle()"></div>
      <div class="mobile-nav">
        <div class="mobile-nav__header">
          NavegaciÃ³n
          <button sukaButton="plain" (click)="toggle()" size="sm"><suka-icon icon="x"></suka-icon></button>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None
})
export class MobileNavigation {
  @HostBinding('attr.role') role = 'complementary';
  @HostBinding('class.mobile-navigation') hostClass = true;
  /**
   * Controls the expanded (`true`) or collapsed (`false`) state when on a small screen.
   */
  @HostBinding('class.mobile-navigation--expanded') @Input() expanded = false;
  /**
   * Controls the hidden (`true`) or visible (`false`) state
   */
  @HostBinding('class.mobile-navigation--hidden') @Input() hidden = false;

  constructor() { }

  toggle() {
    this.expanded = !this.expanded;
  }
}
